import React from 'react'
import styles from './PlayPauseStyles'
import { Icon } from 'semantic-ui-react'

export default ({
  onClick, paused, className, ariaLabelPlay, ariaLabelPause
}) => {
  return (
    <div className={styles.component}>
      <Icon
        className={styles.button}
        onClick={onClick}
        name={paused
          ? 'play'
          : 'pause'
        } />
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/PlayPause/PlayPause.js